import { Fragment, useEffect } from "react";
import { Container } from "../Container/Container";
import { ClubsSchedule } from "./data";
import {
  CellNote,
  ClubGrid,
  ClubName,
  ClubPlace,
  ClubRowHead,
  ClubSlot,
  EmptyCell,
  GridScroll,
  Head,
  Legend,
  MobileCard,
  MobileCardHead,
  MobileCardMeta,
  MobileCardTitle,
  MobileCell,
  MobileList,
  MobileMeta,
  MobileRow,
  MobileRows,
  MobileSubject,
  MobileTime,
  Page,
  SlotGroup,
  SlotLabel,
  SlotTime,
  Subtitle,
  Title,
} from "./styled";

export const ClubsScheduleView = ({ schedule }: { schedule: ClubsSchedule }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { title, subtitle, legend, rows } = schedule;
  const columns = Math.max(...rows.map((row) => row.slots.length));

  return (
    <Container>
      <Page>
        <Head>
          <Title>{title}</Title>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </Head>

        <GridScroll>
          <ClubGrid $columns={columns}>
            {rows.map((row) => (
              <Fragment key={row.name}>
                <ClubRowHead>
                  <ClubName>{row.name}</ClubName>
                  {row.place && <ClubPlace>{row.place}</ClubPlace>}
                </ClubRowHead>
                {Array.from({ length: columns }, (_, index) => {
                  const slot = row.slots[index];
                  if (!slot) {
                    return <EmptyCell key={`${row.name}-${index}`} />;
                  }
                  return (
                    <ClubSlot key={`${row.name}-${index}`} $tone={row.tone}>
                      {slot.label && <SlotLabel>{slot.label}</SlotLabel>}
                      {slot.times.map((time) => (
                        <SlotTime key={time}>{time}</SlotTime>
                      ))}
                      {slot.group && <SlotGroup>{slot.group}</SlotGroup>}
                      {slot.note && <CellNote>{slot.note}</CellNote>}
                    </ClubSlot>
                  );
                })}
              </Fragment>
            ))}
          </ClubGrid>
        </GridScroll>

        <MobileList>
          {rows.map((row) => (
            <MobileCard key={row.name}>
              <MobileCardHead>
                <MobileCardTitle>{row.name}</MobileCardTitle>
                {row.place && <MobileCardMeta>{row.place}</MobileCardMeta>}
              </MobileCardHead>
              <MobileRows>
                {row.slots.map((slot, index) =>
                  slot ? (
                    <MobileRow key={`${row.name}-${index}`} $tone={row.tone}>
                      <MobileCell>
                        {slot.times.map((time) => (
                          <MobileTime key={time}>{time}</MobileTime>
                        ))}
                      </MobileCell>
                      <MobileCell>
                        {slot.label && <SlotLabel>{slot.label}</SlotLabel>}
                        {slot.group && <MobileSubject>{slot.group}</MobileSubject>}
                        {slot.note && <MobileMeta>{slot.note}</MobileMeta>}
                      </MobileCell>
                    </MobileRow>
                  ) : null
                )}
              </MobileRows>
            </MobileCard>
          ))}
        </MobileList>

        {legend && <Legend>{legend}</Legend>}
      </Page>
    </Container>
  );
};
